const { isEmptyObject } = require("jquery");
window.$ = window.jQuery = require("jquery");

(function (proxied) {
    window.alert = function () {
        $(".popup-variation-options").addClass("active");
        // return proxied.apply(this, arguments);
    };
})();

$(document).ready(function () {
    $(".popup-variation-options ").on("click", function () {
        $(this).removeClass("active");
    });

    // demande de devis
    $(".sur-devis .devis-btn").on("click", function (e) {
        if ($(this).text() == "Demande de devis") {
            e.preventDefault();
            let $ref = $(".ref-ean-reviews .ref").text();
            $ref = $ref.split(" ");
            $ref = $ref[2];
            let $id = $(this).val();
            window.location.href =
                php_datas.devis_url + "?ref=" + $ref + "&id=" + $id;
        }
    });
    $(".remove_from_cart_button").on("click", function () {
        $(this).parent(".mini_cart_item").remove();
    });

    // clear cart
    $(".woocommerce-cart .fitt-empty-cart").on("click", function () {

        let data = new FormData();

        $(".woocommerce-cart .cart-total").addClass("loading");

        $.ajax({
            url: wc_add_to_cart_params.wc_ajax_url
                .toString()
                .replace("%%endpoint%%", "interplast_api_clear_cart_url"),
            type: "post",
            data: data,
            contentType: false,
            processData: false,
            dataType: "html",
            success: function (d) {
                window.location.reload()
            }
        });
    });

    if (window.location.href.indexOf("checkout") > -1) {
        $("#shipping_first_name").removeAttr('placeholder value');
        $("#shipping_last_name").removeAttr('placeholder value');
        $("#shipping_phone").removeAttr('placeholder value');
        $("#shipping_company").removeAttr('placeholder value');
        $("#shipping_address_1").removeAttr('placeholder value');
        $("#shipping_address_2").removeAttr('placeholder value');
        $("#shipping_city").removeAttr('placeholder value');
        $("#shipping_postcode").removeAttr('placeholder value');
    }


    // Produit variables
    $(".references-table #total-quantity").on("change", function () {
        // $quantity = $(this).children("option:selected").val();
        $quantity = $(this).val();
        $price = $(this)
            .parent(".input")
            .next(".price.unit")
            .children(".html-price")
            .data("value");
        $total = $price * $quantity;
        $total = $total.toFixed(2);

        // $total = Math.round($total * 100) / 100;
        $total = String($total).replace('.', ',');
        // console.log($total, $price);
        $(this)
            .parent(".input")
            .siblings(".price.total")
            .replaceWith('<td class="ref price total">' + $total + "€</td>");
    });

    //Produit variables Mobile
    $(".ref-mobile  #total-quantity").on("change", function () {
        // $quantity = $(this).children("option:selected").val();
        $quantity = $(this).val();
        $price = $(this)
            .parent(".qty")
            .parent(".qty_div")
            .next(".price_div")
            .children(".unit")
            .data("value");


        //console.log($price);

        $total = $price * $quantity;
        $total = Math.round($total * 100) / 100;

        totalText = (new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' })).format($total)

        $(this)
            .parent(".qty")
            .parent(".qty_div")
            .next(".price_div")
            .children(".total")
            .children(".price_total")
            .replaceWith('<div class="price_total">' + totalText + "</div>");
    });

    if (
        $(".woocommerce-MyAccount-navigation-link--adviser").hasClass("is-active")
    ) {
        $("header .popup").addClass("active");
    }

    //checkout delivery choice
    $(".delivery .selection .c_c_box #rdv").on("click", function (e) {
        $("#order_review #shipping_method #shipping_method_0_local_pickup1")
            .prop("checked", true)
            .attr("spellcheck", "false")
            .attr("checked", "checked");
        $("#order_review #shipping_method #shipping_method_0_flat_rate3")
            .removeAttr("spellcheck")
            .removeAttr("checked");
        $("#shipping_fee_price strong").replaceWith("<strong> 0 € HT</strong>");

        $fixed_shipping_total = parseFloat($("#shipping_fee_price").data("value"));
        $fixed_tva = parseFloat($(".totals-adviser .totals .tva").data("tva"));
        $fixed_total = parseFloat(
            $(".totals-adviser .totals .total_ht").data("totalht")
        );

        $shipping_fee = 0;
        $tva = $fixed_total * 1.2 - $fixed_total;
        $total = $fixed_total + $tva;

        $total = Math.round($total * 100) / 100;

        $(".totals-adviser .totals .shipping").replaceWith(
            "<p class='shipping' value='" + $shipping_fee + "'>0 €</p>"
        );
        $(".totals-adviser .totals .tva").replaceWith(
            "<p class='tva' data-tva='" +
            $fixed_tva +
            "'>" +
            $tva.toFixed(2) +
            "€</p>"
        );
        $(".totals-adviser .totals .total").replaceWith(
            "<p class='total' data-total='" + $fixed_total + "'>" + $total + "€</p>"
        );
    });

    $(
        ".delivery .selection #same-address, .delivery .selection #different-address"
    ).on("click", function (e) {
        $("#order_review #shipping_method #shipping_method_0_flat_rate3")
            .prop("checked", true)
            .attr("spellcheck", "false")
            .attr("checked", "checked");
        $("#order_review #shipping_method #shipping_method_0_local_pickup1")
            .removeAttr("spellcheck")
            .removeAttr("checked");
        $("#shipping_fee_price strong").replaceWith(
            "<strong> " + $shipping_fee + " € HT</strong>"
        );

        $fixed_shipping_total = parseFloat($("#shipping_fee_price").data("value"));
        $fixed_tva = parseFloat($(".totals-adviser .totals .tva").data("tva"));
        $fixed_total = parseFloat(
            $(".totals-adviser .totals .total_ht").data("totalht")
        );

        $shipping_fee = $fixed_shipping_total;

        $total_ht = $fixed_total + $shipping_fee;
        $tva = $total_ht * 1.2 - $total_ht;

        $total = $fixed_total + $shipping_fee + $tva;

        $total = Math.round($total * 100) / 100;

        $(".totals-adviser .totals .shipping").replaceWith(
            "<p class='shipping' value='" +
            $shipping_fee +
            "'> " +
            $shipping_fee +
            " €</p>"
        );
        $(".totals-adviser .totals .tva").replaceWith(
            "<p class='tva' data-tva='" +
            $fixed_tva +
            "'>" +
            $tva.toFixed(2) +
            "€</p>"
        );
        $(".totals-adviser .totals .total").replaceWith(
            "<p class='total' data-total='" + $fixed_total + "'>" + $total + "€</p>"
        );

        $("#shipping_fee_price").replaceWith(
            '<span id="shipping_fee_price" class="blue" data-value="' +
            $fixed_shipping_total +
            '"><strong>' +
            $shipping_fee +
            " € HT</strong></span>"
        );
    });

    // Fake input pour le coupon envoie vers vrais input
    $('#apply_coupon_custom').on('click', function(e) {
        e.preventDefault();
        // Récupère le code entré par l'utilisateur
        const couponCode = $('#coupon_code_custom').val();
        // Copie la valeur dans l'input WooCommerce masqué
        $('#coupon_code').val(couponCode);
        // Déclenche le clic sur le bouton WooCommerce
        $( "#apply_coupon" ).trigger( "click" );
    });

    $(".actions.coupon .button").on("click", function () {
        setTimeout(() => {
            var $error = $(".woocommerce-error li").html();
            $("#erreur_coupon").replaceWith(
                '<div id="erreur_coupon">' + $error + "</div>"
            );
        }, 2000);
    });

    if ($(".page-numbers").children().length > 0) {
        $(".allproducts").addClass("active");
    }

    $('.mm-ajouter-au-panier-btn').on('click', function (e) {
        e.preventDefault();

        var variationId = $(this).data('var_id');
        var productId = $(this).data('product_id');

        if ($(this).hasClass('resp')) {
            var quantity = $(this).closest('.cart_v').siblings('.qty_div').find("#total-quantity").val();

            if (typeof (quantity) == "undefined" || quantity == '0') {
                $(this).closest('.cart_v').siblings('.qty_div').find("#total-quantity").addClass('wrong')
                return;
            }
        } else {
            var quantity = $(this).closest('.cart_v').siblings('.ref.input').children('#total-quantity').val();


            if (typeof (quantity) == "undefined" || quantity == '0') {
                $(this).closest('.cart_v').siblings('.ref.input').children('#total-quantity').addClass('wrong')
                return;
            }

        }
        console.log(variationId, quantity);
        // TODO : Vérification la duplication du code
        $.ajax({
            type: 'POST',
            url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
            data: {
                product_id: variationId,
                quantity: quantity
            },
            success: function (response) {
                if (response.error != true) {
                    $.ajax({
                        type: 'POST',
                        url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'interplast_api_add_to_cart'),
                        data: {
                            variation_id: variationId,
                            product_id: productId,
                            quantity: quantity,
                        },
                        success: function (response) {
                            let json = JSON.parse(response);
                            console.log(json);
                            $('body').prepend(json);
                        }
                    });
                }
            }
        });
    });

    // Fix du popup qui ne se ferme pas
    // $("body").on(
    //     "click",
    //     ".popup-add-cart .close-icn, .popup-add-cart .close_popup, .popup-add-cart .background",
    //     function (e) {
    //         let url = window.location.href;
    //         if (url.includes("add-to-cart")) {
    //             $(".popup-add-cart").toggleClass("active");
    //         } else {
    //             window.location.href = url;
    //         }
    //     }
    // );
    $("body").on("click", ".popup-add-cart .close-icn, .popup-add-cart .close_popup, .popup-add-cart .background", function (e) {
        e.preventDefault();
        $(".popup-add-cart").css("display", "none");
    });

    $("body").on("click", ".popup-add-cart .close-icn, .popup-add-cart .close_popup, .popup-add-cart .background", function (e) {
        e.preventDefault();

        let url = window.location.href;
        url = removeURLParameter(url, "add-to-cart");
        url = removeURLParameter(url, "quantity");

        history.replaceState(null, null, url);

        $(".popup-add-cart").removeClass("active");
    });

    function removeURLParameter(url, parameter) {
        const urlParts = url.split("?");
        if (urlParts.length >= 2) {
            const prefix = encodeURIComponent(parameter) + "=";
            let params = urlParts[1].split("&");

            for (let i = params.length - 1; i >= 0; i--) {
                if (params[i].lastIndexOf(prefix, 0) === 0) {
                    params.splice(i, 1);
                }
            }

            return urlParts[0] + (params.length > 0 ? "?" + params.join("&") : "");
        }
        return url;
    }

    var input = document.getElementById("coupon_code");
    if (input) {
        input.addEventListener("keypress", function (event) {
            if (event.key === "Enter") {
                event.preventDefault();
                document.getElementById("apply_coupon").click();
            }
        });
    }


    $('.filter-item-list .name').on('click', function () {
        $(this).next('.filter-items').slideToggle()
    })
     
    $('.woocommerce-cart .toggle-title').on('click', function () {
        $(this).next('.toggle-item').slideToggle()
    })

    $('.woocommerce-checkout .toggle-title').on('click', function () {
        $(this).next('.toggle-item').slideToggle()
    })

    $('.shipping-details-box .shipping-view-more').click(function(e){
        e.preventDefault();
        $('.shipping-view-more').slideUp();
        $('.shipping-details').slideDown();
    })
});
